import { AnalyticsBoundRule } from '../analytics';
import { getMetadata } from '../utils/metadata';

declare global {
  interface Window {
    isHeEventPage?: boolean;
  }
}

function getSocialShareAnalytics(element: Element): Record<string, unknown> {
  const data: Record<string, unknown> = {
    comp: 'social-share-link',
    eventname: 'article-social-share-link-click',
    'shared-article-title': getMetadata('og:title'),
    'shared-article-url': getMetadata('og:url'),
    'shared-article-published-date': getMetadata('article:published_time'),
  };

  const container = element.closest('.social-share-buttons-container');
  if (container && window.isHeEventPage) {
    const eventType = container.getAttribute('data-layer-event-type');
    const eventTitle = container.getAttribute('data-layer-event-title');
    const eventCategory = container.getAttribute('data-layer-event-category');
    if (eventCategory) data.eventCategory = eventCategory;
    if (eventType) data.eventType = eventType;
    if (eventTitle) data.eventTitle = eventTitle;

    const eventTimeslots = document.querySelector('.event-timeslots');
    if (eventTimeslots) {
      const timeslotText = Array.from(eventTimeslots.querySelectorAll('li'))
        .map((item) => (item.querySelector('time') as HTMLElement)?.textContent?.trim())
        .filter(Boolean)
        .join(', ');
      if (timeslotText) data['event-timeslot'] = timeslotText;
    }
  }

  const articleAuthor = getMetadata('article:author');
  if (articleAuthor) data['shared-article-author'] = articleAuthor;
  return data;
}

export function extendSocialShare(rule: AnalyticsBoundRule): AnalyticsBoundRule {
  rule.extendWhen('.social-share-link', (extension) =>
    extension.enrich(({ element }) => getSocialShareAnalytics(element))
  );
  return rule;
}